module.exports = __webpack_public_path__ + "3e1ee628b54062ffbace9f5a36e3ca43.svg";